import i18n from "i18next";
import translationPL from './i18n_pl.json';
import translationEN from './i18n_en.json';
import translationUK from './i18n_uk.json';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: translationEN
  },
  pl: {
    translation: translationPL
  },
  uk: {
    translation: translationUK
  }
};


i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    detection: {
      order: ["cookie"],
      lookupCookie: "django_language"
    },
    resources,

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
